var map = {
	"./consulting/hero.svg": "BU0Y",
	"./hellohr/hero.svg": "RlJW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "It/X";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/hero\.svg$
// module id = It/X
// module chunks = 0